import { DESIRED_COLOR_OPTIONS, MATERIAL_OPTIONS } from '../constants/style-settings';

export const getColorFromName = (name: DESIRED_COLOR_OPTIONS | MATERIAL_OPTIONS) => {
  switch (name) {
    case DESIRED_COLOR_OPTIONS.WHITE:
      return '#FFFFFF';
    case DESIRED_COLOR_OPTIONS.BLACK:
      return '#000000';
    case DESIRED_COLOR_OPTIONS.BLUE:
      return '#0000FF';
    case DESIRED_COLOR_OPTIONS.RED:
      return '#FF0000';
    case DESIRED_COLOR_OPTIONS.GREEN:
      return '#00FF00';
    case DESIRED_COLOR_OPTIONS.YELLOW:
      return '#FFFF00';
    case DESIRED_COLOR_OPTIONS.GRAY:
      return '#808080';
    case DESIRED_COLOR_OPTIONS.BROWN:
      return '#A52A2A';
    case DESIRED_COLOR_OPTIONS.ORANGE:
      return '#FFA500';
    case DESIRED_COLOR_OPTIONS.PURPLE:
      return '#800080';
    case DESIRED_COLOR_OPTIONS.PINK:
      return '#FFC0CB';
    case DESIRED_COLOR_OPTIONS.BEIGE:
      return '#F5F5DC';
    case DESIRED_COLOR_OPTIONS.GOLD:
      return '#FFD700';
    case DESIRED_COLOR_OPTIONS.SILVER:
      return '#C0C0C0';
    case DESIRED_COLOR_OPTIONS.BRONZE:
      return '#CD7F32';
    case MATERIAL_OPTIONS.WOOD:
      return '#8B4513';
    case MATERIAL_OPTIONS.LEATHER:
      return '#3B2B20';
    case MATERIAL_OPTIONS.COPPER:
      return '#7C4D3A';
    case MATERIAL_OPTIONS.STEEL:
      return '#2A3439';
    case MATERIAL_OPTIONS.GLASS:
      return '#F5F5F5';
    case MATERIAL_OPTIONS.MARBLE:
      return '#FFFFFF';
    case MATERIAL_OPTIONS.GRANITE:
      return '#4E5452';
    case MATERIAL_OPTIONS.CONCRETE:
      return '#D3D3D3';
    case MATERIAL_OPTIONS.BRICK:
      return '#B22222';
    case MATERIAL_OPTIONS.CERAMIC:
      return '#0000FF';
    case MATERIAL_OPTIONS.PORCELAIN:
      return '#FAF0E6';
    case MATERIAL_OPTIONS.BAMBOO:
      return '#E4D00A';
    case MATERIAL_OPTIONS.VELVET:
      return '#50C878';
    case MATERIAL_OPTIONS.COTTON:
      return '#F8F8FF';
    case MATERIAL_OPTIONS.RATTAN:
      return '#D8BFD8';
    default:
      return '#FFFFFF';
  }
};
